'use client';

import { usePathname } from 'next/navigation';
import { IceJiLogo } from '@/components/logo/IceJi';
import { cn } from '@/libs';
import { useEffect } from 'react';
export const Nav = () => {
  const pathName = usePathname();
  useEffect(() => {
    console.log(pathName);
  }, [pathName]);
  return <nav className='-translate-x-1/2 fixed top-0 left-1/2 w-full max-w-6xl p-4'>
      <div className='flex h-12 items-center justify-between overflow-hidden rounded-lg border border-foreground/10 bg-foreground/7 pr-2 backdrop-blur 2xl:h-14 2xl:pr-4'>
        <div className='aspect-square h-full bg-foreground/10 fill-foreground p-2'>
          <IceJiLogo />
        </div>
        <div>
          <ul className='flex gap-4 *:cursor-pointer'>
            <li className={cn('anim-config', pathName === '/status' || pathName === '/' ? 'opacity-100' : 'opacity-40 hover:opacity-100')}>
              Status
            </li>
            <li className={cn('anim-config', pathName === '/maintenance' ? 'opacity-100' : 'opacity-40 hover:opacity-100')}>
              Maintenance
            </li>
            <li className={cn('anim-config', pathName === '/incidents' ? 'opacity-100' : 'opacity-40 hover:opacity-100')}>
              Previous incidents
            </li>
          </ul>
        </div>
        <button className='anim-config rounded-lg border border-foreground/20 bg-foreground/10 px-4 py-1 text-sm hover:bg-foreground/25 2xl:py-2'>
          Get in touch
        </button>
      </div>
    </nav>;
};